import { PortalModule } from '@angular/cdk/portal';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GetFormControlPipe } from './get-form-control.pipe';
import { LocalizePipe } from './localize.pipe';
import { LocalizeDatePipe } from './localizeDate.pipe';
import { LocalizeNumberPipe } from './localizeNumber.pipe';
import { LocalizeOrTranslatePipe } from './localizeOrTranslate.pipe';
import { SafeHtmlPipe } from './safehtml.pipe';

const pipes = [
    LocalizePipe,
    LocalizeNumberPipe,
    LocalizeOrTranslatePipe,
    SafeHtmlPipe,
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        GetFormControlPipe,
        RouterModule,
        PortalModule,
        LocalizeDatePipe
    ],
    declarations: [...pipes],
    exports: [...pipes, LocalizeDatePipe, GetFormControlPipe],
    providers: [DatePipe, ...pipes],
})
export class PipesModule { }
